import React from "react";
import { Helmet } from "react-helmet";

import Config from "../../../Common/constants/EnvironmentConstants";
import IntensiveHeroDark from "../../components/IntensiveHeroDark/IntensiveHeroDark";
import WhyStudentsChooseDark from "../../components/WhyStudentsChooseDark/WhyStudentsChooseDark";
import RecentlyPlacedLearnersDark from "../../components/RecentlyPlacedLearnersDark/RecentlyPlacedLearnersDark";
import CoursesSectionDark from "../../components/CoursesSectionDark/CoursesSectionDark";
import NextStepCtaDark from "../../components/NextStepCtaDark/NextStepCtaDark";
import FooterDark from "../../components/FooterDark/FooterDark";
import IntensiveReachFormScripts from "../../components/IntensiveReachFormScripts/IntensiveReachFormScripts";

import "../../components/IntensiveEnglishShared/IntensiveEnglishShared.css";
import "../../components/IntensiveEnglishReachShared/IntensiveEnglishReachShared.css";

export default function IntensiveEnglishReachRoute() {
  const urlForSeo = Config.DOMAIN_ORIGIN + "intensive-english/reach";
  return (
    <>
      <Helmet>
        <title>
          Intensive English | A Proven Program To Get You a Software Developer
        </title>
        <meta name="robots" content="noindex" />
        <meta
          name="description"
          content="Intensive offers multiple job tracks such as Java and MERN Full Stack, Data Analytics, and QA/Automation Testing. Start your IT career in a powerful way."
        />
        <link rel="canonical" href={urlForSeo} />
        <meta
          property="og:title"
          content="Intensive English | A Proven Program To Get You a Software Developer"
        />
        <meta
          property="og:description"
          content="Intensive offers multiple job tracks such as Java and MERN Full Stack, Data Analytics, and QA/Automation Testing. Start your IT career in a powerful way."
        />
        <meta property="og:url" content={urlForSeo} />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:image"
          content="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/intensive-og.png"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Intensive English | A Proven Program To Get You a Software Developer"
        />
        <meta
          name="twitter:description"
          content="Intensive offers multiple job tracks such as Java and MERN Full Stack, Data Analytics, and QA/Automation Testing. Start your IT career in a powerful way."
        />
        <meta
          name="twitter:image"
          content="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/intensive-og.png"
        />
        <meta name="twitter:url" content={urlForSeo} />
      </Helmet>
      <div className="intensive-reach-page">
        <IntensiveHeroDark />
        <WhyStudentsChooseDark />
        <RecentlyPlacedLearnersDark />
        <CoursesSectionDark />
        <NextStepCtaDark />
        <FooterDark />
      </div>
      <IntensiveReachFormScripts />
    </>
  );
}
